import { observer } from 'mobx-react-lite'
import React from 'react'
import { Text } from '@mxenabled/mxui'
import { Dialog, useGlobalCopyStore } from '../../../../common'

interface ActionProps {
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
}

const DeleteRuleAction: React.FC<ActionProps> = observer(({ onClose, onDelete, isOpen }) => {
  const { common: commonCopy, settings: settingsCopy } = useGlobalCopyStore()

  return (
    <Dialog
      copy={{ title: settingsCopy.delete_rule }}
      isOpen={isOpen}
      onClose={onClose}
      onPrimaryAction={onDelete}
      onSecondaryAction={onClose}
      primaryColor="error"
      primaryText={commonCopy.delete_button}
      secondaryColor="secondary"
      secondaryText={commonCopy.cancel_button}
      sx={{ '& .MuiDialogContent-root': { pt: 0, width: 400 } }}
    >
      <Text truncate={false} variant="body2">
        {settingsCopy.delete_rule_confirm}
      </Text>
    </Dialog>
  )
})

export default DeleteRuleAction
